(function () {
  'use strict';

  var endpoint = '/apps/status/review/widget';

  function requestHtml(productId, page) {
    var url = endpoint + '?product_id=' + encodeURIComponent(productId);
    if (page > 1) url += '&page=' + encodeURIComponent(page);

    return fetch(url, {
      method: 'GET',
      headers: { Accept: 'text/html' },
      credentials: 'same-origin'
    }).then(function (response) {
      return response.text().then(function (body) {
        if (!response.ok) {
          var error = new Error('HTTP ' + response.status);
          error.responseBody = body.slice(0, 300);
          throw error;
        }
        return body;
      });
    });
  }

  function parseWidget(html) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    return parsed.querySelector('.linear-reviews-server-widget');
  }

  function loadWidget(container) {
    requestHtml(container.getAttribute('data-product-id'), 1)
      .then(function (html) {
        var widget = parseWidget(html);
        if (!widget) throw new Error('Răspunsul pentru recenzii nu este valid.');
        container.innerHTML = '';
        container.appendChild(document.importNode(widget, true));
      })
      .catch(function (error) {
        console.error('[Reviews widget] Eroare la încărcare:', error, error.responseBody || '');
        container.textContent = 'Recenziile nu sunt disponibile momentan.';
      });
  }

  function initReviewWidgets() {
    document.querySelectorAll('[data-review-widget]').forEach(loadWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviewWidgets);
  } else {
    initReviewWidgets();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.reviews-load-more');
    if (!button) return;

    var container = button.closest('[data-review-widget]');
    var widget = button.closest('.linear-reviews-server-widget');
    var list = widget && widget.querySelector('.reviews-review-list');
    var productId = container && container.getAttribute('data-product-id');
    var nextPage = parseInt(button.getAttribute('data-next-page'), 10);
    if (!container || !list || !productId || !nextPage || button.disabled) return;

    button.disabled = true;
    var originalLabel = button.textContent;
    button.textContent = 'Se încarcă…';

    requestHtml(productId, nextPage)
      .then(function (html) {
        var nextWidget = parseWidget(html);
        if (!nextWidget) throw new Error('Răspunsul pentru recenzii nu este valid.');

        var nextList = nextWidget.querySelector('.reviews-review-list');
        if (nextList) {
          Array.prototype.forEach.call(nextList.children, function (card) {
            list.appendChild(document.importNode(card, true));
          });
        }

        var nextButton = nextWidget.querySelector('.reviews-load-more');
        if (nextButton) {
          button.setAttribute('data-next-page', nextButton.getAttribute('data-next-page'));
          button.disabled = false;
          button.textContent = nextButton.textContent;
        } else {
          button.remove();
        }
      })
      .catch(function (error) {
        console.error('[Reviews widget] Eroare la paginare:', error, error.responseBody || '');
        button.disabled = false;
        button.textContent = originalLabel;
      });
  });
})();